enum planProfileTestIds {
	planName = 'profile-plan-name',
	productName = 'product-name',
	planNumber = 'plan-number',
	profilePlanBalance = 'planBalance',
	planCommencementDate = 'commencement-date',
	planProfileEmployerPayUser = 'employerPay-user',
	planProfileNumberOfInvestors = 'profile-number-of-investors',
	planReviewDate = 'plan-review-date',
	employerName = 'employer-name',
	employerContact = 'employer-contact',
	employerTitle = 'employer-title',
	employerPhone = 'employer-phone',
	employerFax = 'employer-fax',
	employerEmail = 'employer-email',
	employerAddress = 'employer-address',
	planProfileContainer = 'plan-profile',
	planCategories = 'plan-categories',
	planDetailsFilter = 'plan-details-filter',
	planCategoriesWithdrawalVal = 'category-withdrawal-value',
	planCategoriesFeesRuleVal = 'category-feesRule-value',
	planCategoriesDeathInsuranceVal = 'category-deathInsurance-value',
	planCategoriesTpdInsuranceVal = 'category-totalAndPermanentDisabilityInsurance-value',
	planCategoriesIncomeProtectionVal = 'category-incomeProtectionInsurance-value',
	planCategoriesMembersVal = 'category-members-value',
	planCategoriesDisclaimer = 'plan-commission-value',
	memberDemoMovementAsAtDate = 'movement-as-at-date',
	memberDemoInvestorAsAtDate = 'investors-as-at-date',
	memberDemoInvestorStartValue = 'investors-start-value',
	memberDemoInvestorExitValue = 'investors-exit-value',
	memberDemoInvestorNew = 'investors-new',
	memberDemoInvestorsTotal = 'total-investors',
	memberDemoBenefitAsAtDate = 'benefit-as-at-date',
	memberDemoPlanCategories = 'members-plan-categories',
	memberDemoPlanName = 'plan-name',
	memberDemoPlanMembers = 'plan-members',
	memberDemoPlanStatus = 'plan-status',
	memberDemoAverageInvestorAsAtDate = 'average-investors-as-at-date',
	memberDemoAverageInvestor = 'average-investors',
	memberDemoInvestorAgeGroup = 'age-group',
	memberDemoInvestorAverageBalance = 'average-balance',
	memberDemoInvestorNumber = 'number-of-investors',
	memberDemoInvestorTotal = 'average-investors-total',
	memberDemoInvestorTotalAverageBal = 'total-average-balance',
	memberDemoAverageInvestorTotal = 'total-of-investors',
	memberAccountBalTableHeader = 'memberBenefitAccountBal',
	memberMySuperAccountBalTableHeader = 'mySuperAccountBal',
	memberBenefitsTable = 'memberBenefits',
	memberBenefitsDetails = 'memberBenefitsDetails',
	memberInvestorNameLink = 'member-investor-name',
	memberAccountNumber = 'member-account-number',
	memberAge = 'member-age',
	memberMySuperBalance = 'member-mySuper-bal',
	memberAccountBal = 'member-account-bal',
	memberDeathInsurance = 'member-death-insurance',
	memberTpdInsurance = 'member-tpd-insurance',
	memberIncomeProtection = 'member-income-protection',
	memberInsuranceComm = 'member-insurance-comm',
	downloadCsv = 'download-csv',
	memberTransactions = 'memberTransactions',
	memberTransactionsOpeningBalHeader = 'memberTransactionsOpeningBalanceHeader',
	memberTransactionsTableRow = 'memberTransactionsTableRow',
	transactionOpeningBalance = 'transaction-opening-bal',
	transactionAmountsInDeposit = 'transaction-deposit',
	transactionPremiums = 'transaction-premiums',
	transactionAmountsOutFees = 'transaction-fees',
	transactionTaxes = 'transaction-taxes',
	transactionPayment = 'transaction-payment',
	transactionClosingEarnings = 'transaction-closing-earnings',
	transactionBalance = 'transaction-balance',
	planBalanceComponent = 'plan-balance-component',
	planBalanceAsAtDate = 'plan-balance-as-at-date',
	planBalance = 'plan-balance',
	planExpenseAccount = 'plan-expense-account',
	planPolicyCommitteeMembers = 'policyCommitteeMember',
	planInvestmentContainer = 'plan-investments',
	planInvestmentBalAsAtDate = 'investment-date',
	planInvestmentBalance = 'investment-balance',
	planDefaultInvestmentOption = 'default-investment',
	planActiveChoiceOption = 'active-investment',
	planDefaultStrategyOption = 'default-strategy',
	planInvestmentFunds = 'investment-funds',
	quickFilter = 'quick-filter-button',
}

export default planProfileTestIds;
